import React from "react";
import {
    BrowserRouter,
    Routes,
    Route,
} from "react-router-dom";
import Home from "./pages/home";
import Ibagreement from "./pages/ibagreement";
import Ibsupplemental from "./pages/ibsupplemental";
import Rate from "./pages/rate"

function App() {
    return (
        <>
            <BrowserRouter>
                <Routes>
                    <Route
                        exact
                        path="/"
                        element={<Home />}
                    />
                    <Route
                        exact
                        path="/ibagreement"
                        element={<Ibagreement />}
                    />
                    <Route
                        exact
                        path="/ibsupplemental"
                        element={<Ibsupplemental />}
                    />
                     <Route
                        exact
                        path="/rate"
                        element={<Rate />}
                    />
                </Routes>
            </BrowserRouter>
        </>
    );
}

export default App;